import { useState, useRef, useCallback } from "react";
import { FaChair, FaChevronDown } from "react-icons/fa";
import PortalDropdown from "./PortalDropdown";

const FamilyTableDropdown = ({ family, tables, onSelect }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleClose = useCallback(() => setOpen(false), []);

    const currentTableId = family.reservedTableId?._id || family.reservedTableId;
    const currentTable = tables.find(t => t._id === currentTableId);

    const attendingCount = family.familyMembers.filter(m => m.attending === true).length;
    const canAssign = attendingCount > 0;

    const availableTables = tables.filter(t =>
        t._id !== currentTableId &&
        (t.seats - t.reservedSeats) >= attendingCount
    );

    return (
        <div ref={anchorRef}>
            <button
                onClick={() => setOpen(o => !o)}
                disabled={!canAssign && !currentTable}
                className="w-full flex items-center justify-between gap-2 px-3 py-2 bg-white border border-gray-200 rounded-xl text-sm text-gray-700 hover:border-rose-300 hover:bg-rose-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <span className="flex items-center gap-2">
                    <FaChair className="text-gray-400 text-xs flex-shrink-0" />
                    <span className="truncate capitalize">
                        {currentTable ? currentTable.name : 'Bez stola'}
                    </span>
                </span>
                <FaChevronDown className={`text-xs text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>
            {!canAssign && !currentTable && (
                <p className="text-xs text-gray-400 mt-1">Barem jedan član mora potvrditi dolazak.</p>
            )}
            <PortalDropdown anchorRef={anchorRef} open={open} onClose={handleClose}>
                <div className="bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
                    {canAssign && availableTables.length === 0 && !currentTable && (
                        <p className="px-4 py-3 text-sm text-gray-400 text-center">
                            Nema stolova s dovoljno mjesta ({attendingCount})
                        </p>
                    )}
                    {canAssign && availableTables.map(table => (
                        <button
                            key={table._id}
                            onMouseDown={() => { onSelect(family._id, table); setOpen(false); }}
                            className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-left hover:bg-rose-50 transition border-b border-gray-50 last:border-0"
                        >
                            <span className="capitalize font-medium text-gray-800">{table.name}</span>
                            <span className="text-xs text-gray-400">{table.reservedSeats}/{table.seats}</span>
                        </button>
                    ))}
                    {currentTable && (
                        <button
                            onMouseDown={() => { onSelect(family._id, null); setOpen(false); }}
                            className="w-full px-4 py-2.5 text-sm text-left text-red-500 hover:bg-red-50 transition border-t border-gray-100"
                        >
                            Ukloni rezervaciju
                        </button>
                    )}
                </div>
            </PortalDropdown>
        </div>
    );
};

export default FamilyTableDropdown;
